import { SOCIAL_LINKS } from '../data/social';

const InstagramIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <rect x="2" y="2" width="20" height="20" rx="5" stroke="currentColor" strokeWidth="1.8" fill="none" />
    <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="1.8" fill="none" />
    <circle cx="17.5" cy="6.5" r="1" fill="currentColor" />
  </svg>
);

const WhatsAppIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
    <path fill="#25D366" d="M12 2C6.48 2 2 6.48 2 12c0 1.89.52 3.66 1.44 5.17L2 22l4.98-1.42A9.96 9.96 0 0012 22c5.52 0 10-4.48 10-10S17.52 2 12 2z" />
    <path fill="#fff" d="M16.6 14.4c-.3-.15-1.75-.86-2.03-.96-.27-.1-.47-.15-.67.15-.2.3-.77.96-.94 1.16-.17.2-.35.22-.64.07-.3-.15-1.25-.46-2.39-1.48-.88-.78-1.47-1.75-1.64-2.04-.17-.3-.02-.46.13-.61.13-.13.3-.35.44-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.6-.92-2.19-.24-.58-.49-.5-.67-.51-.17-.01-.37-.01-.57-.01-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.48 0 1.47 1.07 2.88 1.22 3.08.15.2 2.1 3.2 5.09 4.49.71.31 1.27.49 1.7.63.72.23 1.37.2 1.88.12.57-.09 1.75-.72 2-1.41.25-.69.25-1.28.17-1.41-.07-.13-.27-.2-.57-.35z" />
  </svg>
);

const LinkedInIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
    <rect width="24" height="24" rx="4" fill="#0A66C2" />
    <path fill="#fff" d="M7.5 9.5H5v9h2.5v-9zM6.25 8.4a1.45 1.45 0 110-2.9 1.45 1.45 0 010 2.9zM19 18.5h-2.5v-4.4c0-1.05-.02-2.4-1.46-2.4-1.47 0-1.69 1.14-1.69 2.32v4.48H10.9v-9h2.4v1.23h.03c.33-.63 1.15-1.3 2.37-1.3 2.53 0 3 1.67 3 3.84v5.23z" />
  </svg>
);

const FacebookIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
    <rect width="24" height="24" rx="4" fill="#1877F2" />
    <path fill="#fff" d="M16 8h-2a1 1 0 00-1 1v2h3l-.5 3H13v7h-3v-7H8v-3h2V9a4 4 0 014-4h2v3z" />
  </svg>
);

const YoutubeIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
    <rect width="24" height="24" rx="4" fill="#FF0000" />
    <path fill="#fff" d="M19.2 7.8c-.2-.6-.7-1-1.3-1.1-1.4-.2-5.9-.2-5.9-.2s-4.5 0-5.9.2c-.6.1-1.1.5-1.3 1.1-.3 1.2-.3 4.2-.3 4.2s0 3 .3 4.2c.2.6.7 1 1.3 1.1 1.4.2 5.9.2 5.9.2s4.5 0 5.9-.2c.6-.1 1.1-.5 1.3-1.1.3-1.2.3-4.2.3-4.2s0-3-.3-4.2z" />
    <polygon fill="#FF0000" points="10.2,14.5 15,12 10.2,9.5" />
  </svg>
);

const ICONS = {
  YouTube: YoutubeIcon,
  WhatsApp: WhatsAppIcon,
  Instagram: InstagramIcon,
  LinkedIn: LinkedInIcon,
  Facebook: FacebookIcon,
};

export default function SocialLinks({ size = 'md', className = '' }) {
  const dim = size === 'lg' ? 44 : 38;
  return (
    <div className={`social-links ${className}`}>
      {SOCIAL_LINKS.map(s => {
        const Ico = ICONS[s.label];
        return (
          <a
            key={s.label}
            href={s.url}
            target="_blank"
            rel="noreferrer"
            className="social-links__item"
            title={s.label}
            aria-label={s.label}
            style={{ '--brand': s.brand, color: s.brand, width: dim, height: dim }}
          >
            <Ico />
          </a>
        );
      })}
    </div>
  );
}
